export default __webpack_public_path__ + "static/media/MNP.30901e0e.jpg";